import React from "react";

type TextInputProps = {
    value: string | number |undefined;
    onChange: (updatedValue: string) => void;
    labelText: string | undefined;
    inputId: string;
    containerClassName?: string;
    errorMessage?: string;
    placeHolder?: string;
    readOnly: boolean;
    type?: string;
    style?: React.CSSProperties;
    boldLabel?: boolean;
    labelClassName?: string;
    inputClassName?: string;
    autoComplete?: string;
};

function TextInput({
    value,
    errorMessage,
    onChange,
    inputId,
    labelText,
    readOnly,
    containerClassName,
    placeHolder,
    type,
    style = {},
    boldLabel = true,
    labelClassName = "",
    inputClassName = "",
    autoComplete
}: TextInputProps) {
    const errorMessageId = `${inputId}__error-message`;

    const className = `form-control ${readOnly ? "read-only-input" : ""} ${inputClassName}`;

    return (
        <div className={`form-group ${containerClassName ?? ""}`}>
            {labelText ? (
                <label className={`form-label ${labelClassName} ${boldLabel ? "fw-bold" : ""}`} htmlFor={inputId}>
                    {labelText}
                </label>
            ) : null}
            <input
                id={inputId}
                className={className}
                type={type ?? "text"}
                value={value ?? ""}
                onChange={(e) => onChange(e.target.value)}
                readOnly={readOnly}
                placeholder={placeHolder}
                aria-errormessage={errorMessageId}
                style={style}
                autoComplete={autoComplete}
            />
            <span id={errorMessageId} className="text-danger">
                {errorMessage}
            </span>
        </div>
    );
}

export default TextInput;
